export const DEFAULT_TOKEN = 'NSE_INDEX|Nifty 50';

export const DEFAULT_TOKEN_SHORT_NAME = 'Nifty 50';

export const AUTHORIZED_ROUTES = <const>{
  CHARTS: '/charts/:id',
  DEFAULT_CHART: `/charts/${DEFAULT_TOKEN}`,
};

export const EXTERNAL_LINKS = <const>{
  TRADING_APP: {
    PROD: 'https://tv.upstox.com',
    QA: 'https://qa-tradingview.upstox.com',
    UAT: 'https://uat-tradingview.upstox.com',
  },
  LOGIN_SERVICE: {
    PROD: 'https://login.upstox.com',
    UAT: 'https://uat-login.upstox.com',
    QA: 'https://login.upstox.com',
  },
  LOGIN_SERVICE_LOGOUT: {
    PROD: 'https://login.upstox.com/logout',
    UAT: 'https://uat-login.upstox.com/logout',
    QA: 'https://login.upstox.com/logout',
  },
  OPEN_ACCOUNT: {
    PROD: 'https://upstox.com/new-demat-account/profile',
    UAT: 'https://uat.upstox.com/new-demat-account/profile',
    QA: 'https://upstox.com/new-demat-account/profile',
  },
  VERIFY_EDIS: {
    PROD: 'https://cdsl.upstox.com/edis-verification',
    QA: 'https://cdsl.upstox.com/edis-verification',
    UAT: 'https://uat-cdsl.upstox.com/edis-verification',
  },
  ADD_FUNDS: {
    PROD: 'https://pro.upstox.com/funds/securities/wallet?depositFunds=true',
    QA: 'https://qa-pro.upstox.com/funds/securities/wallet?depositFunds=true',
    UAT: 'https://uat-pro.upstox.com/funds/securities/wallet?depositFunds=true',
  },
  HELP: {
    PROD: 'https://help.upstox.com/support/solutions/folders/277476',
    QA: 'https://help.upstox.com/support/solutions/folders/277476',
    UAT: 'https://help.upstox.com/support/solutions/folders/277476',
  },
  TERMS_AND_CONDITIONS: {
    PROD: 'https://upstox.com/files/terms-and-condition/tv-web.pdf',
    QA: 'https://upstox.com/files/terms-and-condition/tv-web.pdf',
    UAT: 'https://upstox.com/files/terms-and-condition/tv-web.pdf',
  },
  FINGERPRINT_PRO_SCRIP_URL: {
    PROD: 'https://service.upstox.com/device-id/agent?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>',
    QA: 'https://service.upstox.com/device-id/agent?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>',
    UAT: 'https://service-uat.upstox.com/device-id/agent?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>',
  },
  FINGERPRINT_PRO_END_POINT: {
    PROD: 'https://service.upstox.com/device-id/result?region=ap',
    QA: 'https://service.upstox.com/device-id/result?region=ap',
    UAT: 'https://service-uat.upstox.com/device-id/result?region=ap',
  },
  CHART_SAVE_HELP_LINK: {
    PROD: 'https://help.upstox.com/support/solutions/articles/260256-what-is-the-chart-sync-feature-on-upstox-tradingview-platform-and-what-are-its-benefits-and-limitations-',
    QA: 'https://help.upstox.com/support/solutions/articles/260256-what-is-the-chart-sync-feature-on-upstox-tradingview-platform-and-what-are-its-benefits-and-limitations-',
    UAT: 'https://help.upstox.com/support/solutions/articles/260256-what-is-the-chart-sync-feature-on-upstox-tradingview-platform-and-what-are-its-benefits-and-limitations-',
  },
  SURVEILLANCE_SCRIPS_LEARN_MORE: {
    PROD: 'https://help.upstox.com/support/solutions/folders/277837',
    QA: 'https://help.upstox.com/support/solutions/folders/277837',
    UAT: 'https://help.upstox.com/support/solutions/folders/277837',
  },
  ODR_PORTAL_LINK: {
    PROD: 'https://smartodr.in',
    QA: 'https://smartodr.in',
    UAT: 'https://smartodr.in',
  },
  TBT_VIDEO_LINK: {
    PROD: 'https://www.youtube.com/embed/zu7zoe25NBs',
    QA: 'https://www.youtube.com/embed/zu7zoe25NBs',
    UAT: 'https://www.youtube.com/embed/zu7zoe25NBs',
  },
  HOLDING_DISCREPANCY: {
    PROD: 'https://account.upstox.com/reports/holding/discrepancy',
    QA: 'https://account.upstox.com/reports/holding/discrepancy',
    UAT: 'https://uat-my-4.upstox.com/reports/holding/discrepancy',
  },
};

export const QUERY_ROUTES = <const>{};

export const ROUTES = <const>{
  ...AUTHORIZED_ROUTES,
};
